<template>
  <div class="about">
    <h1>Event's Details</h1>
  </div>
</template>
